var _circle, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g2, _path41, _path42, _path43, _path44, _path45, _ellipse, _ellipse2, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _g3, _path94, _path95, _path96, _path97, _path98, _g4, _path99, _ellipse3, _rect57, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEthernetOnboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 203,
    viewBox: "0 0 298 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 156.7,
    cy: 89.1169,
    r: 89.1169,
    fill: "#4A5366"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18480_1266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3681 142.478C36.9323 135.558 34.2708 125.622 33.5611 121.187L64.4342 140.349L69.2249 149.753L67.628 152.592L71.354 155.431L68.1603 157.737C61.5953 160.754 57.6918 158.891 55.5626 157.737C52.1559 155.892 44.2115 146.914 41.3681 142.478Z",
    fill: "#AFAFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0614 91.2008C37.2161 83.5357 37.8216 71.8609 37.8204 71.6833C37.8192 71.5057 37.9978 70.7961 37.9978 70.7961L40.6588 71.5059L64.2572 122.961L65.6767 129.349L65.8533 150.285L39.0614 91.2008Z",
    fill: "url(#paint0_linear_18480_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1079 119.699L52.3117 117.712L54.0949 121.38L53.7892 123.622L52.1079 119.699Z",
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0549 119.801L52.3097 117.712L53.1758 119.495L53.0229 121.89L52.0549 119.801Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8714 158.447C67.2759 156.85 66.2114 153.301 65.8551 150.285L70.6458 150.64L71.7103 152.059L213.834 101.669C212.041 106.45 209.845 109.595 208.78 110.424L73.8395 159.689C70.6471 160.221 69.76 159.157 68.8714 158.447Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8505 150.107L65.3182 128.283L66.5603 129.348C67.6248 131.122 70.4638 130.057 72.2381 129.348L215.958 82.3284C217.2 91.5548 214.893 98.0606 213.828 101.668L71.8832 152.059C68.0507 153.62 66.2645 151.408 65.8505 150.107Z",
    fill: "#DDDDDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.904 42.9266L39.6573 69.971C37.7971 70.4038 37.8074 70.9931 38.0451 71.2337C44.0619 78.8847 58.815 112.554 65.4394 128.433C66.5852 131.609 69.3795 130.599 71.1707 130.058L213.571 84.0729C216.974 83.1715 215.601 81.3068 214.467 80.2842C201.86 66.7141 174.709 50.2068 162.71 43.6495C160.398 42.3861 158.233 42.3857 155.904 42.9266Z",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.989 42.9392L40.8356 69.5539C38.9929 69.9798 39.0032 70.5594 39.2387 70.7959C45.2004 78.319 59.8208 111.428 66.3857 127.042C67.5213 130.164 70.2892 129.171 72.0635 128.639L213.122 83.3935C216.493 82.5064 215.133 80.6729 214.009 79.6675C201.518 66.3246 174.619 50.0956 162.731 43.6489C160.441 42.4069 158.295 42.4069 155.989 42.9392Z",
    fill: "url(#paint1_linear_18480_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M213.052 83.355C216.423 82.4679 215.063 80.6344 213.939 79.6289C211.477 76.999 210.091 75.7854 206.735 73.0283C198.634 75.679 81.2498 110.985 62.2462 116.996C65.0142 123.238 64.4588 122.586 66.316 127.003C67.4515 130.126 70.2195 129.132 71.9938 128.6L213.052 83.355Z",
    fill: "url(#paint2_linear_18480_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.6551 97.9427L38.8808 90.668L65.8504 150.285V156.318L40.6551 97.9427Z",
    fill: "url(#paint3_linear_18480_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.8556 156.319L40.6603 97.9436C36.686 98.6533 34.8053 102.084 34.4504 103.621C28.5891 126.688 41.5431 144.076 54.5002 155.254C59.6396 159.157 64.0221 157.797 65.8556 156.319Z",
    fill: "url(#paint4_linear_18480_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0549 120.463L52.1059 117.967L53.1248 120.056L52.921 122.196L52.0549 120.463Z",
    fill: "#B5B5B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3117 117.712L52.1079 117.967L53.1269 120.056L52.9231 122.195L53.2797 122.042L53.4326 120.056L52.3117 117.712Z",
    fill: "#AFACAC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7261 129.355C45.1212 129.684 44.4326 129.815 43.7717 129.829C42.44 129.858 41.3886 128.857 40.7929 127.666C40.2489 126.578 39.9836 125.219 40.7855 124.305C41.4869 123.504 42.4392 123.241 43.3447 123.253C44.6272 123.269 45.5859 124.299 46.1595 125.446C46.8385 126.804 47.06 128.63 45.7261 129.355Z",
    fill: "url(#paint5_linear_18480_1266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.7731 129.713C44.7007 129.73 44.6281 129.744 44.5552 129.757C42.7525 130.059 40.5107 128.034 41.5742 126.547C41.9945 125.96 42.3086 125.659 42.9732 125.376C43.512 125.146 44.2336 124.993 44.9738 125.213C47.0186 125.819 46.8508 129.231 44.7731 129.713Z",
    fill: "url(#paint6_linear_18480_1266)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.3718 132.342L82.6784 148.311L105.035 140.326L103.438 124.535C103.438 123.4 102.373 123.471 101.841 123.648L81.6138 130.39C80.1943 130.816 80.5492 131.987 80.3718 132.342Z",
    fill: "#9B9B99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.033 140.327L103.436 124.535L104.146 138.73L105.033 140.327Z",
    fill: "#7C7C7C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M100.517 137.716L83.4892 143.643L83.69 144.634L100.995 138.507L100.517 137.716Z",
    fill: "#1A4531"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7417 141.923L99.7105 136.246L100.065 137.842L101.84 139.617L102.372 138.73L102.727 137.842V134.294L102.372 129.148L101.307 126.487L96.6942 125.777L89.242 128.084L87.2903 129.148L82.6771 132.52V138.907L83.7417 141.923Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M99.9291 134.892L83.5598 140.614L83.8763 143.588L100.131 137.959L99.9291 134.892Z",
    fill: "#343434"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3743 132.357L82.464 146.464C82.4829 146.591 82.6162 146.668 82.7361 146.62L84.1368 146.06C84.219 146.027 84.2698 145.944 84.2617 145.856L83.2256 134.631C83.217 134.538 83.2746 134.451 83.3641 134.422L86.9749 133.274C87.0579 133.247 87.1143 133.17 87.1143 133.083V131.599C87.1143 131.513 87.1694 131.437 87.2511 131.409L88.5744 130.968C88.6561 130.941 88.7112 130.865 88.7112 130.778V128.759C88.7112 128.673 88.7655 128.597 88.8463 128.57L94.6564 126.578C94.7862 126.533 94.9213 126.63 94.9213 126.767V128.347C94.9213 128.481 95.0504 128.577 95.1788 128.539L96.4381 128.161C96.5665 128.122 96.6956 128.219 96.6956 128.353V129.765C96.6956 129.899 96.8258 129.995 96.9544 129.956L101.063 128.692C101.187 128.653 101.315 128.743 101.321 128.873L101.828 139.34C101.834 139.477 101.972 139.566 102.099 139.517L104.013 138.782C104.093 138.751 104.145 138.671 104.141 138.585L103.438 124.535C103.438 123.4 102.373 123.471 101.841 123.648L81.6141 130.39C80.2131 130.811 80.3679 131.957 80.372 132.328C80.3721 132.338 80.3728 132.347 80.3743 132.357Z",
    fill: "#292929"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1167 140.683V139.441L84.1003 137.666",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8882 139.972V138.73L85.8718 136.956",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6678 139.264V138.022L87.6515 136.247",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4393 138.73V137.488L89.423 135.714",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M94.2117 138.198V136.956L91.1954 135.182",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9877 137.489V136.246L92.9714 134.472",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7629 136.779V135.537L94.7465 133.762",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M111.055 121.835L112.38 137.68L133.07 130.315L132.715 115.411C132.183 114.701 132.006 114.346 131.472 113.991L112.533 120.154C111.291 120.686 111.231 121.125 111.055 121.835Z",
    fill: "#9B9B99"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.063 130.293L132.707 115.468L132.35 128.969L133.063 130.293Z",
    fill: "#7C7C7C"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M130.87 126.855L113.842 132.781L114.043 133.773L131.348 127.646L130.87 126.855Z",
    fill: "#1A4531"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M113.139 132.073L127.257 126.727L128.174 127.992L129.703 129.835L131.77 128.879L132.125 127.992V124.443L131.77 119.298L130.705 116.636L126.092 115.927L118.64 118.233L116.688 119.298L112.075 122.669V129.056L113.139 132.073Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M128.075 125.148L113.245 130.161L113.563 133.134L128.075 127.899L128.075 125.148Z",
    fill: "#343434"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M111.056 122.295L112.205 135.743C112.217 135.873 112.347 135.958 112.471 135.915L114.124 135.336C114.208 135.307 114.262 135.226 114.258 135.137L113.713 124.689C113.708 124.599 113.764 124.517 113.85 124.489L117.854 123.163C117.936 123.136 117.991 123.059 117.991 122.973V121.311C117.991 121.224 118.048 121.147 118.13 121.121L119.095 120.811C119.177 120.785 119.234 120.708 119.234 120.621V118.649C119.234 118.563 119.289 118.486 119.371 118.459L124.827 116.675C124.956 116.632 125.089 116.729 125.089 116.865V118.657C125.089 118.793 125.221 118.889 125.35 118.848L126.15 118.589C126.279 118.547 126.411 118.643 126.411 118.779V120.129C126.411 120.267 126.547 120.363 126.676 120.318L129.61 119.307C129.741 119.262 129.877 119.361 129.875 119.499L129.707 129.577C129.704 129.715 129.839 129.814 129.97 129.77L132.228 129.017C132.308 128.99 132.362 128.917 132.365 128.832L132.718 115.31C132.718 114.175 132.009 113.713 131.476 113.891L112.533 120.104C111.114 120.53 111.056 121.408 111.056 122.295Z",
    fill: "#292929"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M117.91 129.725L117.941 128.483L114.971 126.633",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M119.707 129.061L119.739 127.819L116.768 125.969",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M121.493 128.573L121.525 127.332L118.554 125.482",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M123.28 128.085L123.311 126.844L120.341 124.994",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M125.069 127.42L125.1 126.179L122.13 124.329",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M126.866 126.756L126.898 125.514L123.927 123.665",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M139.894 112.868V127.898L158.949 121.122L159.611 106.194C159.079 105.484 159.431 105.785 158.898 105.43L141.065 111.187C139.824 111.719 140.07 112.158 139.894 112.868Z",
    fill: "#9B9B99"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M158.947 121.123L159.609 106.909L157.979 120.053L158.947 121.123Z",
    fill: "#7C7C7C"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M157.475 117.658L141.053 123.721L141.053 124.603L157.475 118.524L157.475 117.658Z",
    fill: "#1A4531"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M141.018 123.313L154.825 118.575L155.844 120.664L157.271 119.135L157.474 117.301V115.722L157.78 114.244L158.035 110.067L157.78 108.029L154.214 107.214L146.724 109.608L144.816 110.84L141.018 114.244L140.763 120.613L141.018 123.313Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M155.13 115.773L140.854 120.755L141.203 123.724L154.875 118.626L155.13 115.773Z",
    fill: "#343434"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M139.894 112.971V126.144C139.894 126.28 140.028 126.377 140.157 126.334L141.139 126.007C141.218 125.98 141.272 125.908 141.276 125.824L141.672 115.502C141.675 115.42 141.728 115.348 141.806 115.321L145.517 114.037C145.598 114.009 145.652 113.933 145.652 113.848V112.297C145.652 112.212 145.705 112.137 145.785 112.109L147.097 111.643C147.177 111.614 147.23 111.539 147.23 111.454V109.704C147.23 109.617 147.287 109.54 147.37 109.513L152.421 107.908C152.55 107.867 152.682 107.963 152.682 108.099V109.752C152.682 109.885 152.808 109.981 152.936 109.945L153.702 109.73C153.829 109.695 153.955 109.791 153.955 109.923V110.966C153.955 111.101 154.087 111.197 154.216 111.156L156.72 110.364C156.858 110.32 156.995 110.433 156.979 110.577L155.876 120.404C155.86 120.549 156 120.662 156.138 120.616L157.861 120.042C157.935 120.017 157.987 119.953 157.997 119.877L159.509 107.621C159.66 106.463 159.862 105.155 158.931 105.126C158.91 105.125 158.888 105.128 158.868 105.135L141.473 110.78C140.054 111.206 139.894 112.084 139.894 112.971Z",
    fill: "#292929"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M145.005 120.318L145.036 119.076L142.066 117.226",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M146.803 119.654L146.834 118.412L143.863 116.562",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M148.589 119.166L148.62 117.925L145.65 116.075",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M150.375 118.678L150.407 117.437L147.436 115.587",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M152.164 118.013L152.196 116.772L149.225 114.922",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M153.962 117.349L153.993 116.107L151.023 114.258",
    stroke: "#696147",
    strokeWidth: 0.7
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M166.331 116.334L167.452 104.106L184.672 98.655L181.361 112.564L169.286 116.691L166.331 116.334Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M169.338 114.602L166.774 115.459L166.92 114.032L169.464 113.205L169.338 114.602Z",
    fill: "#413D1A"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M181.123 110.705L178.529 111.685L178.665 110.373L181.518 109.303L181.123 110.705Z",
    fill: "#23391F"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.949 114.041L169.445 113.225L169.343 114.55L170.923 114.041L170.872 115.569L176.833 113.531L176.884 112.257L178.565 111.646L178.667 110.372L181.418 109.353L183.456 100.081L168.121 105.227L166.949 114.041ZM167.357 113.532L169.65 112.819V114.143L171.178 113.685V115.162L176.579 113.328V112.054L178.311 111.443L178.413 110.169L181.164 109.15L183.049 100.54L168.478 105.431L167.357 113.532Z",
    fill: "#292929"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18480_1266",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 165,
    y: 96,
    width: 21,
    height: 23
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M183.729 112.322L165.163 118.931L166.368 104.252C166.416 103.692 166.413 103.08 166.871 102.925L184.575 96.9219C185.546 96.7686 185.546 97.6853 185.546 97.9972L185.546 97.9973L183.729 112.322Z",
    fill: "#C4C4C4"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18480_1266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M183.47 100.045L168.108 105.213L166.797 115.416L170.924 114.04L170.873 115.579L164.956 117.659L166.364 102.724L185.495 96.5142L185.65 97.7424L182.607 111.615L176.809 113.782L176.885 112.257L181.125 110.705L183.47 100.045Z",
    fill: "#A5A5A5"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M183.573 112.374L185.543 97.793L182.602 111.614L183.573 112.374Z",
    fill: "#7C7C7C"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M165.162 118.981L165.264 117.504L182.602 111.512L183.574 112.373L165.162 118.981Z",
    fill: "#9B9B99"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M202.254 105.839L204.147 94.5283L200.886 105.635L202.254 105.839Z",
    fill: "#7C7C7C"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M192.369 109.304L192.528 108.387L200.884 105.636L202.259 105.839L192.369 109.304Z",
    fill: "#9B9B99"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M203.294 94.6628L194.695 97.4392C194.518 97.4964 194.388 97.6472 194.356 97.8306L192.665 107.704C192.601 108.079 192.962 108.385 193.321 108.261L200.684 105.718C200.837 105.665 200.956 105.54 201.001 105.384L203.928 95.2777C204.039 94.8927 203.675 94.5396 203.294 94.6628Z",
    fill: "#363636"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.876,
    cy: 100.531,
    rx: 3.91113,
    ry: 2.56477,
    transform: "rotate(-44.8035 197.876 100.531)",
    fill: "#101010"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.014,
    cy: 99.6906,
    rx: 0.898191,
    ry: 1.10132,
    transform: "rotate(31.4342 197.014 99.6906)",
    fill: "#737373"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8902 123.897L82.2848 123.434L82.3522 123.899L80.4232 124.539L79.9235 121.194L80.46 121.015L80.8902 123.897Z",
    fill: "#BDBDBD"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0492 123.667L82.5473 120.323L83.4039 120.041C83.6675 119.954 83.916 119.944 84.1494 120.013C84.3838 120.08 84.5821 120.215 84.7445 120.419C84.9063 120.621 85.0167 120.866 85.0756 121.155L85.1087 121.335C85.1618 121.64 85.1513 121.931 85.077 122.206C85.0038 122.48 84.8705 122.717 84.6773 122.92C84.484 123.122 84.2469 123.27 83.9659 123.363L83.0492 123.667ZM83.1548 120.613L83.5162 123.025L83.8341 122.922C84.1208 122.827 84.3283 122.658 84.4565 122.414C84.5857 122.169 84.624 121.877 84.5714 121.54C84.536 121.307 84.4861 121.11 84.4216 120.95C84.3389 120.745 84.2229 120.601 84.0734 120.518C83.9254 120.436 83.7534 120.424 83.5574 120.482L83.1548 120.613Z",
    fill: "#BDBDBD"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6308 121.226C87.5935 121.007 87.4284 120.89 87.1355 120.874L86.938 120.868C86.5727 120.862 86.2954 120.804 86.1059 120.693C85.9164 120.582 85.7939 120.421 85.7382 120.21C85.6902 120.026 85.6987 119.848 85.7635 119.675C85.8294 119.501 85.9406 119.347 86.0971 119.213C86.2536 119.079 86.4347 118.98 86.6403 118.917C86.8387 118.856 87.0284 118.841 87.2093 118.873C87.3897 118.903 87.5447 118.978 87.6743 119.097C87.8035 119.215 87.8961 119.368 87.9523 119.557L87.4172 119.732C87.3726 119.564 87.2931 119.448 87.1789 119.384C87.0661 119.321 86.9249 119.314 86.7555 119.366C86.5851 119.419 86.455 119.506 86.365 119.628C86.2766 119.749 86.2455 119.883 86.2718 120.03C86.3039 120.224 86.475 120.328 86.7853 120.342L86.9676 120.347C87.3387 120.355 87.6167 120.418 87.8019 120.535C87.9865 120.651 88.1071 120.821 88.1637 121.045C88.2084 121.227 88.2014 121.403 88.1427 121.57C88.0836 121.736 87.9749 121.885 87.8164 122.018C87.6594 122.151 87.4711 122.252 87.2515 122.321C87.0439 122.389 86.8412 122.408 86.6435 122.378C86.4471 122.349 86.2791 122.273 86.1393 122.153C85.9991 122.03 85.9006 121.872 85.844 121.677L86.3812 121.501C86.4292 121.684 86.5193 121.808 86.6514 121.872C86.7835 121.936 86.9435 121.938 87.1312 121.879C87.306 121.824 87.4385 121.739 87.5289 121.624C87.6208 121.508 87.6547 121.376 87.6308 121.226Z",
    fill: "#BDBDBD"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0528 121.676L88.553 118.33L89.5248 118.01C89.867 117.898 90.1481 117.888 90.368 117.979C90.5888 118.068 90.7324 118.246 90.7986 118.514C90.8744 118.829 90.7635 119.123 90.4659 119.393C90.6116 119.396 90.7403 119.448 90.8521 119.547C90.9639 119.647 91.0431 119.784 91.0897 119.958C91.1655 120.254 91.1248 120.522 90.9677 120.761C90.812 120.999 90.5603 121.175 90.2128 121.291L89.0528 121.676ZM89.3635 119.988L89.5198 121.034L90.0831 120.849C90.2526 120.793 90.3818 120.7 90.4707 120.571C90.5597 120.442 90.5891 120.295 90.5589 120.132C90.5297 119.976 90.4686 119.867 90.3755 119.804C90.2825 119.742 90.1597 119.733 90.0072 119.777L89.3635 119.988ZM89.2989 119.561L89.7928 119.4C89.9694 119.341 90.0996 119.251 90.1832 119.13C90.2669 119.009 90.2951 118.874 90.2678 118.724C90.2141 118.441 90.0307 118.346 89.7174 118.438L89.1584 118.621L89.2989 119.561Z",
    fill: "#BDBDBD"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M93.3916 119.978C93.2764 120.227 93.0839 120.393 92.8141 120.476C92.6611 120.523 92.5219 120.528 92.3965 120.489C92.2725 120.45 92.1674 120.373 92.0812 120.258C91.996 120.142 91.933 119.993 91.8922 119.812L91.6419 118.207L92.1567 118.037L92.407 119.649C92.419 119.704 92.4356 119.757 92.4568 119.806C92.5308 119.981 92.6523 120.044 92.8213 119.996C93.0515 119.929 93.2052 119.777 93.2822 119.539L93.0169 117.751L93.5318 117.58L93.9053 120.066L93.4231 120.226L93.3916 119.978Z",
    fill: "#BDBDBD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8915 118.683C95.8686 118.532 95.7423 118.463 95.5126 118.479C95.2838 118.492 95.1256 118.494 95.0378 118.487C94.6972 118.458 94.4887 118.312 94.4124 118.048C94.3495 117.834 94.3871 117.628 94.5254 117.429C94.6646 117.229 94.8636 117.087 95.1224 117.004C95.3724 116.925 95.5985 116.928 95.8005 117.013C96.004 117.099 96.1413 117.253 96.2124 117.477L95.7012 117.644C95.6681 117.535 95.6103 117.46 95.5278 117.42C95.4449 117.378 95.3486 117.374 95.239 117.407C95.1246 117.445 95.0355 117.506 94.9717 117.59C94.9094 117.673 94.8868 117.763 94.904 117.858C94.9275 117.997 95.0507 118.058 95.2736 118.042C95.4961 118.024 95.6638 118.021 95.7766 118.032C96.1052 118.063 96.3088 118.214 96.3876 118.485C96.4298 118.636 96.4238 118.783 96.3696 118.925C96.3163 119.065 96.2235 119.19 96.0911 119.299C95.9583 119.408 95.8057 119.488 95.6334 119.54C95.3761 119.623 95.1385 119.619 94.9205 119.529C94.704 119.438 94.5592 119.278 94.4862 119.048L94.9844 118.885C95.0291 119.01 95.0985 119.093 95.1925 119.135C95.2865 119.176 95.3968 119.176 95.5232 119.136C95.6507 119.093 95.7477 119.032 95.8144 118.952C95.8821 118.87 95.9078 118.781 95.8915 118.683Z",
    fill: "#BDBDBD"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5773 118.516L98.0647 118.686L97.6646 116.012L96.9531 116.542L96.8785 116.048L97.9827 115.19L98.0609 115.164L98.5773 118.516Z",
    fill: "#BDBDBD"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4314 116.996L73.975 117.285L72.9413 114.786L72.3789 115.473L72.1873 115.012L73.0517 113.912L73.1214 113.868L74.4314 116.996Z",
    fill: "#BDBDBD"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M105.879 106.908L104.117 107.828L103.998 107.473L104.557 105.812C104.659 105.499 104.677 105.255 104.612 105.078C104.567 104.953 104.496 104.865 104.4 104.817C104.303 104.767 104.197 104.768 104.084 104.821C103.944 104.888 103.851 104.991 103.805 105.132C103.758 105.271 103.766 105.424 103.828 105.591L103.392 105.821C103.318 105.649 103.29 105.475 103.309 105.297C103.329 105.118 103.393 104.954 103.5 104.805C103.608 104.654 103.749 104.536 103.921 104.451C104.158 104.334 104.379 104.305 104.583 104.365C104.789 104.424 104.941 104.568 105.039 104.796C105.15 105.059 105.138 105.404 105.003 105.831L104.947 106.004L104.55 107.145L105.749 106.519L105.879 106.908Z",
    fill: "#BDBDBD"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M132.347 96.99L132.543 96.8558C132.66 96.7738 132.737 96.6737 132.771 96.5555C132.805 96.4374 132.791 96.3216 132.729 96.2081C132.67 96.1007 132.598 96.0353 132.511 96.0118C132.424 95.9874 132.333 96.0067 132.238 96.07C132.142 96.1339 132.079 96.2187 132.049 96.3245C132.02 96.4303 132.031 96.5349 132.082 96.6384L131.725 96.8893C131.652 96.7651 131.617 96.6329 131.621 96.4925C131.625 96.3522 131.665 96.2191 131.74 96.0933C131.816 95.9658 131.918 95.858 132.047 95.77C132.246 95.6372 132.44 95.587 132.63 95.6192C132.821 95.6498 132.974 95.7623 133.09 95.9567C133.153 96.0623 133.18 96.1809 133.171 96.3125C133.162 96.4431 133.115 96.5831 133.029 96.7326C133.259 96.6919 133.449 96.7673 133.599 96.9591L133.65 97.0316C133.774 97.2381 133.804 97.4547 133.741 97.6813C133.678 97.9073 133.538 98.0933 133.32 98.2394C133.195 98.3246 133.066 98.3759 132.931 98.3933C132.796 98.4096 132.669 98.3896 132.551 98.3331C132.432 98.2749 132.333 98.1839 132.253 98.0603L132.61 97.8135C132.674 97.913 132.752 97.9746 132.845 97.9982C132.938 98.0202 133.035 97.998 133.137 97.9316C133.249 97.8591 133.32 97.762 133.349 97.6403C133.379 97.5178 133.361 97.3969 133.296 97.2777C133.23 97.1575 133.148 97.0885 133.049 97.0708C132.951 97.0524 132.846 97.0795 132.735 97.1522L132.503 97.3116L132.347 96.99Z",
    fill: "#BDBDBD"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M159.349 89.0276L158.586 89.4444L158.676 89.9905L158.32 90.1849L157.989 87.8074L158.296 87.6396L160.118 89.2034L159.761 89.3985L159.349 89.0276ZM158.531 89.1158L159.102 88.8039L158.37 88.1422L158.531 89.1158Z",
    fill: "#BDBDBD"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M185.962 82.2574L184.96 80.2478L185.649 79.9043C185.876 79.7909 186.072 79.7502 186.236 79.782C186.4 79.8139 186.527 79.92 186.617 80.1004C186.663 80.1924 186.679 80.2876 186.666 80.386C186.653 80.4844 186.609 80.5777 186.534 80.6659C186.657 80.6412 186.768 80.6551 186.868 80.7076C186.968 80.7588 187.047 80.8414 187.104 80.9555C187.198 81.1441 187.209 81.3193 187.138 81.4811C187.068 81.6425 186.921 81.7794 186.695 81.8918L185.962 82.2574ZM185.859 81.1764L186.172 81.8044L186.56 81.6109C186.67 81.5563 186.742 81.4865 186.776 81.4015C186.811 81.3164 186.804 81.2256 186.756 81.129C186.652 80.9201 186.492 80.8666 186.276 80.9685L185.859 81.1764ZM185.731 80.9197L186.073 80.749C186.182 80.6948 186.254 80.6282 186.291 80.5491C186.328 80.4687 186.324 80.3834 186.279 80.2932C186.229 80.1938 186.165 80.1363 186.086 80.1206C186.008 80.1044 185.909 80.1262 185.789 80.1858L185.45 80.3552L185.731 80.9197Z",
    fill: "#BDBDBD"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3967 67.229L55.0013 68.5658L55.418 66.9835L55.8255 66.8856L55.9487 68.7931L55.6392 68.8675L55.5971 68.2217L55.5759 67.4192L55.1537 68.9841L54.9298 69.0379L54.3069 67.6803L54.3937 68.5455L54.433 69.1573L54.1236 69.2317L54.0017 67.3239L54.3967 67.229Z",
    fill: "#BDBDBD"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M58.413 68.2009L57.2169 68.4884L57.1986 68.2573L57.7839 67.3436C57.8924 67.1712 57.9403 67.0271 57.9275 66.9113C57.9193 66.829 57.8899 66.766 57.8395 66.7223C57.7889 66.6777 57.7254 66.6628 57.6492 66.6775C57.5553 66.6965 57.4839 66.7447 57.4351 66.8221C57.3861 66.8986 57.3677 66.9918 57.3798 67.1015L57.0833 67.1741C57.0647 67.0597 57.0744 66.9505 57.1123 66.8464C57.1512 66.7422 57.2141 66.6535 57.3012 66.5802C57.3888 66.5059 57.4909 66.4561 57.6072 66.4309C57.7673 66.3959 57.9042 66.4118 58.0178 66.4785C58.1322 66.5451 58.2019 66.6542 58.2269 66.8061C58.2537 66.9806 58.1944 67.186 58.049 67.4223L57.9894 67.5178L57.5796 68.1431L58.3934 67.9475L58.413 68.2009Z",
    fill: "#BDBDBD"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8864 65.9097L60.491 67.2466L60.9077 65.6643L61.3153 65.5664L61.4384 67.4739L61.129 67.5483L61.0869 66.9025L61.0657 66.1L60.6435 67.6649L60.4196 67.7187L59.7966 66.3611L59.8835 67.2263L59.9227 67.8381L59.6133 67.9125L59.4915 66.0047L59.8864 65.9097Z",
    fill: "#BDBDBD"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M111.675 113.898L113.009 113.456L113.073 113.9L111.228 114.512L110.75 111.313L111.263 111.142L111.675 113.898Z",
    fill: "#BDBDBD"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M113.74 113.679L113.26 110.48L114.079 110.21C114.331 110.127 114.569 110.118 114.792 110.184C115.016 110.248 115.206 110.377 115.361 110.571C115.516 110.765 115.622 110.999 115.678 111.276L115.71 111.448C115.76 111.74 115.75 112.018 115.679 112.281C115.609 112.543 115.482 112.77 115.297 112.964C115.112 113.157 114.885 113.299 114.617 113.388L113.74 113.679ZM113.841 110.758L114.186 113.065L114.49 112.966C114.765 112.875 114.963 112.713 115.086 112.48C115.209 112.246 115.246 111.967 115.196 111.644C115.162 111.421 115.114 111.233 115.052 111.08C114.973 110.883 114.862 110.745 114.719 110.667C114.578 110.588 114.413 110.576 114.226 110.632L113.841 110.758Z",
    fill: "#BDBDBD"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M118.122 111.344C118.086 111.134 117.929 111.022 117.648 111.007L117.459 111.001C117.11 110.995 116.845 110.94 116.664 110.834C116.482 110.728 116.365 110.574 116.312 110.371C116.266 110.196 116.274 110.026 116.336 109.861C116.399 109.694 116.505 109.546 116.655 109.418C116.805 109.29 116.978 109.195 117.175 109.135C117.364 109.076 117.546 109.062 117.719 109.093C117.891 109.122 118.04 109.193 118.164 109.307C118.287 109.42 118.376 109.567 118.43 109.747L117.918 109.915C117.875 109.754 117.799 109.643 117.69 109.582C117.582 109.521 117.447 109.515 117.285 109.564C117.122 109.615 116.997 109.699 116.911 109.815C116.827 109.931 116.797 110.059 116.822 110.2C116.853 110.385 117.017 110.484 117.313 110.498L117.488 110.503C117.843 110.511 118.109 110.571 118.286 110.683C118.462 110.793 118.578 110.956 118.632 111.17C118.675 111.345 118.668 111.513 118.612 111.673C118.555 111.831 118.451 111.974 118.3 112.101C118.15 112.228 117.969 112.325 117.759 112.391C117.561 112.456 117.367 112.474 117.178 112.446C116.99 112.418 116.829 112.346 116.695 112.23C116.561 112.113 116.467 111.961 116.413 111.775L116.927 111.607C116.973 111.782 117.059 111.9 117.185 111.961C117.312 112.023 117.465 112.025 117.644 111.968C117.811 111.916 117.938 111.835 118.025 111.724C118.113 111.614 118.145 111.487 118.122 111.344Z",
    fill: "#BDBDBD"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M119.482 111.774L119.004 108.574L119.934 108.268C120.261 108.161 120.53 108.151 120.74 108.238C120.952 108.323 121.089 108.494 121.152 108.749C121.225 109.051 121.119 109.332 120.834 109.591C120.973 109.594 121.096 109.643 121.203 109.738C121.31 109.833 121.386 109.964 121.431 110.131C121.503 110.414 121.464 110.67 121.314 110.898C121.165 111.126 120.924 111.295 120.592 111.406L119.482 111.774ZM119.779 110.16L119.929 111.16L120.468 110.983C120.63 110.929 120.753 110.841 120.839 110.717C120.924 110.593 120.952 110.453 120.923 110.297C120.895 110.148 120.837 110.043 120.748 109.984C120.659 109.924 120.541 109.915 120.395 109.958L119.779 110.16ZM119.718 109.751L120.19 109.597C120.359 109.541 120.484 109.455 120.564 109.339C120.644 109.223 120.671 109.094 120.644 108.95C120.593 108.68 120.418 108.589 120.118 108.677L119.583 108.852L119.718 109.751Z",
    fill: "#BDBDBD"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M123.632 110.15C123.522 110.388 123.338 110.547 123.08 110.626C122.934 110.672 122.801 110.676 122.681 110.639C122.562 110.601 122.462 110.528 122.379 110.418C122.298 110.307 122.237 110.165 122.198 109.991L121.959 108.456L122.451 108.293L122.691 109.835C122.702 109.888 122.718 109.938 122.738 109.985C122.809 110.152 122.925 110.213 123.087 110.167C123.307 110.103 123.454 109.958 123.528 109.73L123.274 108.02L123.767 107.857L124.124 110.234L123.663 110.387L123.632 110.15Z",
    fill: "#BDBDBD"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M126.024 108.911C126.002 108.766 125.881 108.701 125.661 108.716C125.442 108.728 125.291 108.731 125.207 108.723C124.881 108.696 124.682 108.556 124.609 108.304C124.549 108.099 124.585 107.902 124.717 107.712C124.85 107.52 125.04 107.385 125.288 107.306C125.527 107.229 125.743 107.232 125.937 107.314C126.131 107.396 126.263 107.544 126.331 107.758L125.842 107.918C125.81 107.813 125.755 107.741 125.676 107.703C125.596 107.663 125.504 107.659 125.4 107.691C125.29 107.727 125.205 107.785 125.144 107.866C125.084 107.945 125.063 108.031 125.079 108.122C125.102 108.255 125.219 108.313 125.433 108.298C125.645 108.281 125.806 108.278 125.914 108.288C126.228 108.318 126.423 108.462 126.498 108.722C126.539 108.867 126.533 109.007 126.481 109.143C126.43 109.276 126.341 109.396 126.215 109.501C126.088 109.604 125.942 109.681 125.777 109.731C125.531 109.81 125.303 109.806 125.095 109.72C124.888 109.633 124.749 109.48 124.679 109.261L125.156 109.105C125.199 109.224 125.265 109.304 125.355 109.343C125.445 109.383 125.55 109.383 125.671 109.344C125.793 109.304 125.886 109.245 125.95 109.169C126.015 109.09 126.039 109.005 126.024 108.911Z",
    fill: "#BDBDBD"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M129.26 108.53L127.284 109.185L127.22 108.798L128.076 107.174C128.235 106.868 128.295 106.618 128.257 106.424C128.231 106.287 128.173 106.185 128.081 106.118C127.99 106.05 127.88 106.034 127.754 106.07C127.598 106.116 127.485 106.207 127.414 106.344C127.342 106.48 127.324 106.64 127.36 106.823L126.871 106.988C126.823 106.798 126.824 106.612 126.873 106.432C126.923 106.25 127.017 106.092 127.153 105.956C127.29 105.818 127.455 105.719 127.648 105.66C127.913 105.578 128.146 105.586 128.347 105.682C128.55 105.778 128.683 105.952 128.747 106.204C128.817 106.495 128.746 106.85 128.535 107.269L128.448 107.438L127.846 108.551L129.19 108.105L129.26 108.53Z",
    fill: "#BDBDBD"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M139.917 104.921L141.191 104.499L141.252 104.923L139.491 105.507L139.035 102.453L139.525 102.291L139.917 104.921Z",
    fill: "#BDBDBD"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M141.889 104.712L141.43 101.658L142.213 101.401C142.453 101.321 142.68 101.313 142.893 101.376C143.107 101.437 143.288 101.56 143.437 101.746C143.584 101.93 143.685 102.154 143.739 102.418L143.769 102.582C143.818 102.861 143.808 103.126 143.74 103.378C143.673 103.627 143.552 103.845 143.375 104.029C143.199 104.214 142.982 104.349 142.726 104.434L141.889 104.712ZM141.985 101.923L142.315 104.126L142.605 104.032C142.867 103.945 143.057 103.79 143.174 103.568C143.292 103.344 143.327 103.077 143.278 102.769C143.246 102.557 143.201 102.377 143.142 102.231C143.066 102.043 142.96 101.912 142.824 101.837C142.689 101.761 142.532 101.75 142.353 101.804L141.985 101.923Z",
    fill: "#BDBDBD"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M146.072 102.483C146.038 102.283 145.887 102.176 145.62 102.162L145.439 102.156C145.106 102.15 144.853 102.097 144.68 101.996C144.507 101.895 144.395 101.748 144.344 101.555C144.3 101.387 144.308 101.225 144.367 101.067C144.427 100.908 144.529 100.767 144.672 100.645C144.814 100.522 144.98 100.432 145.168 100.374C145.349 100.319 145.522 100.305 145.687 100.334C145.852 100.362 145.993 100.43 146.112 100.539C146.23 100.647 146.314 100.787 146.365 100.959L145.877 101.119C145.836 100.965 145.764 100.859 145.659 100.801C145.556 100.743 145.427 100.737 145.273 100.784C145.117 100.833 144.998 100.913 144.916 101.024C144.835 101.134 144.807 101.256 144.831 101.391C144.86 101.568 145.017 101.663 145.3 101.676L145.466 101.68C145.805 101.688 146.059 101.745 146.228 101.852C146.397 101.958 146.507 102.113 146.558 102.317C146.599 102.484 146.593 102.644 146.539 102.797C146.485 102.948 146.386 103.085 146.241 103.206C146.098 103.327 145.926 103.419 145.726 103.483C145.536 103.544 145.351 103.562 145.17 103.535C144.991 103.508 144.838 103.439 144.71 103.329C144.582 103.217 144.492 103.072 144.44 102.894L144.931 102.734C144.975 102.901 145.057 103.014 145.178 103.072C145.298 103.131 145.444 103.133 145.616 103.079C145.775 103.029 145.896 102.951 145.979 102.846C146.063 102.741 146.094 102.62 146.072 102.483Z",
    fill: "#BDBDBD"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M147.37 102.893L146.914 99.839L147.801 99.5468C148.114 99.4446 148.37 99.4351 148.571 99.5182C148.773 99.5995 148.904 99.7623 148.964 100.006C149.033 100.295 148.932 100.562 148.66 100.81C148.793 100.812 148.911 100.859 149.013 100.95C149.115 101.041 149.187 101.166 149.23 101.325C149.299 101.596 149.262 101.84 149.119 102.058C148.976 102.275 148.747 102.437 148.429 102.542L147.37 102.893ZM147.654 101.353L147.797 102.307L148.311 102.139C148.466 102.087 148.584 102.003 148.665 101.885C148.746 101.767 148.773 101.633 148.745 101.484C148.719 101.341 148.663 101.242 148.578 101.185C148.493 101.128 148.381 101.119 148.242 101.16L147.654 101.353ZM147.595 100.963L148.046 100.815C148.207 100.762 148.326 100.68 148.402 100.569C148.479 100.459 148.504 100.335 148.48 100.198C148.431 99.9398 148.263 99.853 147.977 99.9376L147.467 100.105L147.595 100.963Z",
    fill: "#BDBDBD"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M151.332 101.343C151.227 101.57 151.051 101.722 150.804 101.798C150.665 101.841 150.538 101.845 150.423 101.81C150.31 101.774 150.214 101.704 150.135 101.599C150.057 101.493 150 101.357 149.963 101.192L149.734 99.7267L150.204 99.5708L150.433 101.043C150.444 101.093 150.459 101.141 150.478 101.186C150.546 101.346 150.657 101.404 150.811 101.36C151.021 101.299 151.162 101.16 151.232 100.943L150.99 99.3102L151.46 99.1542L151.801 101.423L151.361 101.569L151.332 101.343Z",
    fill: "#BDBDBD"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M153.614 100.161C153.593 100.023 153.478 99.9605 153.268 99.9743C153.059 99.9863 152.915 99.9887 152.835 99.9816C152.524 99.9556 152.333 99.8221 152.264 99.581C152.206 99.3858 152.241 99.1975 152.367 99.0161C152.494 98.8331 152.676 98.7038 152.912 98.6284C153.14 98.5555 153.347 98.5583 153.531 98.6365C153.717 98.7143 153.842 98.8554 153.907 99.0599L153.441 99.2126C153.41 99.1125 153.357 99.0442 153.282 99.0075C153.206 98.9695 153.119 98.9657 153.019 98.9959C152.914 99.0306 152.833 99.0862 152.774 99.1628C152.718 99.2389 152.697 99.3206 152.713 99.4078C152.734 99.5343 152.847 99.5902 153.05 99.5755C153.253 99.5595 153.406 99.5564 153.509 99.5662C153.809 99.5944 153.995 99.7323 154.067 99.98C154.106 100.118 154.1 100.252 154.051 100.382C154.002 100.509 153.917 100.623 153.797 100.724C153.675 100.823 153.536 100.896 153.379 100.944C153.144 101.019 152.927 101.015 152.728 100.933C152.53 100.85 152.398 100.704 152.331 100.494L152.786 100.346C152.827 100.46 152.89 100.536 152.976 100.573C153.062 100.611 153.163 100.611 153.278 100.574C153.394 100.536 153.483 100.48 153.544 100.407C153.606 100.332 153.629 100.25 153.614 100.161Z",
    fill: "#BDBDBD"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M155.068 98.492L155.325 98.4091C155.479 98.3578 155.595 98.2734 155.67 98.1559C155.745 98.0383 155.767 97.9077 155.736 97.7641C155.707 97.6284 155.649 97.5338 155.563 97.4804C155.475 97.4256 155.37 97.4173 155.246 97.4555C155.121 97.4941 155.025 97.5662 154.959 97.6718C154.893 97.7774 154.871 97.8948 154.893 98.0239L154.424 98.1819C154.384 98.0232 154.389 97.8681 154.439 97.7167C154.488 97.5652 154.575 97.4332 154.697 97.3205C154.821 97.2062 154.967 97.1218 155.135 97.0674C155.395 96.9872 155.623 96.9952 155.819 97.0915C156.016 97.186 156.146 97.3578 156.21 97.6068C156.245 97.7421 156.236 97.88 156.184 98.0204C156.132 98.1596 156.035 98.2967 155.894 98.4317C156.157 98.4616 156.34 98.605 156.441 98.862L156.473 98.9572C156.542 99.2221 156.505 99.4676 156.363 99.6939C156.222 99.9197 156.009 100.077 155.725 100.165C155.562 100.218 155.404 100.232 155.252 100.208C155.1 100.182 154.968 100.119 154.857 100.02C154.747 99.918 154.669 99.7871 154.621 99.6267L155.09 99.4734C155.127 99.602 155.192 99.6942 155.285 99.7499C155.379 99.8037 155.493 99.8109 155.625 99.7715C155.771 99.7289 155.879 99.6461 155.95 99.5228C156.022 99.3991 156.041 99.2619 156.009 99.1112C155.976 98.9592 155.909 98.8575 155.807 98.8063C155.706 98.7546 155.583 98.7505 155.439 98.7939L155.135 98.8926L155.068 98.492Z",
    fill: "#BDBDBD"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M171.01 94.1625L171.172 95.2433L170.705 95.3981L170.271 92.4893L171.223 92.1753C171.51 92.0801 171.762 92.084 171.978 92.1871C172.193 92.2889 172.333 92.4725 172.397 92.7377C172.463 93.0122 172.425 93.2605 172.282 93.4827C172.138 93.7036 171.909 93.8665 171.593 93.9714L171.01 94.1625ZM170.949 93.7571L171.485 93.5835C171.654 93.5276 171.777 93.439 171.856 93.3178C171.936 93.1963 171.961 93.0551 171.931 92.8944C171.903 92.7488 171.839 92.6455 171.741 92.5845C171.643 92.5218 171.523 92.5108 171.379 92.5513L170.797 92.7424L170.949 93.7571Z",
    fill: "#BDBDBD"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M174.425 94.2057C174.245 94.2613 174.074 94.2707 173.911 94.234C173.749 94.1968 173.604 94.1133 173.477 93.9835C173.35 93.8524 173.248 93.6897 173.173 93.4954C173.112 93.3409 173.065 93.1524 173.031 92.93C172.999 92.7072 173.002 92.4938 173.039 92.29C173.077 92.0844 173.144 91.905 173.24 91.7515C173.399 91.5004 173.622 91.33 173.909 91.2402C174.183 91.155 174.43 91.1769 174.652 91.3061C174.875 91.4348 175.046 91.6521 175.164 91.9581C175.224 92.1118 175.269 92.296 175.299 92.5109C175.331 92.7241 175.331 92.9303 175.299 93.1295C175.268 93.3271 175.207 93.5041 175.115 93.6604C174.956 93.9313 174.726 94.113 174.425 94.2057ZM174.792 92.434L174.742 92.2282C174.704 92.0884 174.65 91.9658 174.58 91.8604C174.51 91.7537 174.427 91.6827 174.331 91.6473C174.237 91.6103 174.131 91.6089 174.016 91.6431C173.855 91.6907 173.729 91.7822 173.637 91.9176C173.546 92.0526 173.494 92.2291 173.481 92.4473C173.47 92.665 173.506 92.9214 173.59 93.2165C173.654 93.4511 173.749 93.6208 173.876 93.7254C174.003 93.8301 174.15 93.8573 174.318 93.8072C174.538 93.7412 174.691 93.5999 174.775 93.3831C174.861 93.1658 174.875 92.8957 174.817 92.5725L174.792 92.434Z",
    fill: "#BDBDBD"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M177.566 91.7589L176.47 92.1224L176.604 93.0175L177.884 92.5926L177.945 92.9961L176.198 93.5758L175.761 90.6676L177.497 90.0917L177.557 90.4996L176.289 90.9201L176.409 91.7233L177.507 91.3592L177.566 91.7589Z",
    fill: "#BDBDBD"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M192.673 88.4294L190.966 88.9956L190.911 88.6613L191.651 87.2585C191.787 86.994 191.839 86.7783 191.806 86.6112C191.784 86.4924 191.734 86.4042 191.655 86.3467C191.576 86.288 191.481 86.2742 191.372 86.3051C191.238 86.3444 191.14 86.4233 191.078 86.542C191.016 86.6595 191.001 86.7974 191.032 86.9557L190.609 87.098C190.568 86.9337 190.569 86.7735 190.611 86.6173C190.655 86.4607 190.736 86.3237 190.853 86.2063C190.972 86.0873 191.114 86.0022 191.281 85.951C191.51 85.8804 191.711 85.8867 191.884 85.9698C192.059 86.0526 192.174 86.203 192.229 86.4211C192.29 86.6719 192.229 86.9783 192.046 87.3404L191.971 87.4867L191.452 88.448L192.613 88.0628L192.673 88.4294Z",
    fill: "#BDBDBD"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M194.501 86.789L194.816 86.6843L194.872 87.0544L194.557 87.1586L194.648 87.774L194.223 87.9151L194.13 87.3003L193.036 87.6635L192.978 87.3639L193.781 85.1612L194.235 85.0106L194.501 86.789ZM193.428 87.1451L194.075 86.9301L193.914 85.7665L193.891 85.8418L193.428 87.1451Z",
    fill: "#BDBDBD"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M196.353 86.5729L196.638 84.2135L197.14 84.0468L196.686 87.0977L196.258 87.24L194.89 84.7934L195.36 84.6374L196.353 86.5729Z",
    fill: "#BDBDBD"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M198.095 86.6304L197.68 83.8676L198.388 83.6349C198.606 83.5626 198.811 83.5549 199.004 83.6118C199.197 83.6671 199.361 83.7787 199.495 83.9467C199.629 84.1135 199.72 84.3163 199.769 84.5551L199.796 84.7034C199.84 84.9558 199.831 85.1957 199.77 85.4233C199.709 85.6492 199.599 85.8457 199.44 86.0129C199.28 86.1801 199.084 86.3022 198.852 86.3792L198.095 86.6304ZM198.182 84.1075L198.481 86.1L198.743 86.0149C198.98 85.9363 199.151 85.7965 199.257 85.5953C199.364 85.3926 199.396 85.1517 199.352 84.8726C199.323 84.6805 199.282 84.5182 199.229 84.3858C199.16 84.2159 199.064 84.097 198.941 84.029C198.819 83.9607 198.677 83.9507 198.515 83.9991L198.182 84.1075Z",
    fill: "#BDBDBD"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M202.452 84.2385C202.499 84.5259 202.448 84.7844 202.301 85.0137C202.154 85.2419 201.935 85.4014 201.645 85.4923C201.478 85.5439 201.319 85.5528 201.168 85.5192C201.019 85.4851 200.885 85.4079 200.767 85.2878C200.648 85.1665 200.554 85.0163 200.486 84.8372C200.433 84.7032 200.388 84.5122 200.351 84.2643C200.314 84.0151 200.322 83.7781 200.374 83.5534C200.429 83.3283 200.524 83.1407 200.66 82.9906C200.797 82.8401 200.969 82.7326 201.176 82.6679C201.437 82.5865 201.67 82.6004 201.873 82.7095C202.078 82.817 202.231 83.0086 202.333 83.2841L201.893 83.43C201.825 83.2453 201.741 83.1239 201.641 83.0655C201.541 83.0056 201.42 82.9975 201.276 83.0411C201.079 83.0998 200.939 83.224 200.856 83.4136C200.773 83.6032 200.755 83.8449 200.802 84.1387L200.845 84.3893L200.89 84.5777C200.921 84.7041 200.968 84.8174 201.03 84.9175C201.093 85.016 201.169 85.0827 201.256 85.1175C201.343 85.1511 201.439 85.1522 201.546 85.1209C201.884 85.0233 202.041 84.7788 202.016 84.3874L202.452 84.2385Z",
    fill: "#BDBDBD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 69.8151,
    y: 114.333,
    width: 4.8292,
    height: 3.56405,
    rx: 1.78202,
    transform: "rotate(60.9206 69.8151 114.333)",
    fill: "#696969"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 100.567,
    y: 104.391,
    width: 4.7843,
    height: 3.474,
    rx: 1.737,
    transform: "rotate(54.4205 100.567 104.391)",
    fill: "#696969"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 129.107,
    y: 95.6497,
    width: 4.23206,
    height: 2.87991,
    rx: 1.43996,
    transform: "rotate(51.6836 129.107 95.6497)",
    fill: "#696969"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 155.307,
    y: 87.7339,
    width: 4.048,
    height: 2.64422,
    rx: 1.32211,
    transform: "rotate(46.9871 155.307 87.7339)",
    fill: "#696969"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 182.887,
    y: 79.8816,
    width: 4.048,
    height: 2.71798,
    rx: 1.35899,
    transform: "rotate(47.3141 182.887 79.8816)",
    fill: "#CB3131"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 176.034,
    y: 71.4846,
    width: 1.60915,
    height: 2.77933,
    rx: 0.804576,
    transform: "rotate(-41.3699 176.034 71.4846)",
    fill: "#D8D8D8"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 169.955,
    y: 66.5435,
    width: 1.60915,
    height: 2.77933,
    rx: 0.804576,
    transform: "rotate(-41.3699 169.955 66.5435)",
    fill: "#D8D8D8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 187.81,
    y: 76.0332,
    width: 1.60915,
    height: 2.77933,
    rx: 0.804576,
    transform: "rotate(-41.3699 187.81 76.0332)",
    fill: "#D8D8D8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 182.789,
    y: 77.4536,
    width: 1.60915,
    height: 2.77933,
    rx: 0.804576,
    transform: "rotate(-41.3699 182.789 77.4536)",
    fill: "#D8D8D8"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 181.29,
    y: 70.3459,
    width: 1.36464,
    height: 2.35702,
    rx: 0.682322,
    transform: "rotate(-41.3699 181.29 70.3459)",
    fill: "#D8D8D8"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 175.047,
    y: 65.2847,
    width: 1.43838,
    height: 2.48437,
    rx: 0.719189,
    transform: "rotate(-41.3699 175.047 65.2847)",
    fill: "#D8D8D8"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 192.781,
    y: 74.5771,
    width: 1.60915,
    height: 2.77933,
    rx: 0.804576,
    transform: "rotate(-41.3699 192.781 74.5771)",
    fill: "#D8D8D8"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 186.241,
    y: 68.8655,
    width: 1.38279,
    height: 2.38835,
    rx: 0.691393,
    transform: "rotate(-41.3699 186.241 68.8655)",
    fill: "#D8D8D8"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 179.657,
    y: 64.2056,
    width: 1.53067,
    height: 2.64377,
    rx: 0.765333,
    transform: "rotate(-41.3699 179.657 64.2056)",
    fill: "#D8D8D8"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 197.749,
    y: 73.1211,
    width: 1.60915,
    height: 2.77933,
    rx: 0.804576,
    transform: "rotate(-41.3699 197.749 73.1211)",
    fill: "#D8D8D8"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 191.027,
    y: 67.2048,
    width: 1.54164,
    height: 2.66273,
    rx: 0.770822,
    transform: "rotate(-41.3699 191.027 67.2048)",
    fill: "#D8D8D8"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 184.806,
    y: 62.8601,
    width: 1.35695,
    height: 2.34373,
    rx: 0.678475,
    transform: "rotate(-41.3699 184.806 62.8601)",
    fill: "#D8D8D8"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 191.691,
    y: 71.0256,
    width: 1.60915,
    height: 2.77933,
    rx: 0.804576,
    transform: "rotate(-41.3699 191.691 71.0256)",
    fill: "#D8D8D8"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 185.484,
    y: 65.5254,
    width: 1.29803,
    height: 2.24197,
    rx: 0.649017,
    transform: "rotate(-41.3699 185.484 65.5254)",
    fill: "#D8D8D8"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 179.103,
    y: 60.7668,
    width: 1.35408,
    height: 2.33877,
    rx: 0.677039,
    transform: "rotate(-41.3699 179.103 60.7668)",
    fill: "#D8D8D8"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 187.074,
    y: 72.4795,
    width: 1.60915,
    height: 2.77933,
    rx: 0.804576,
    transform: "rotate(-41.3699 187.074 72.4795)",
    fill: "#D8D8D8"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 180.737,
    y: 67.0972,
    width: 1.47507,
    height: 2.54775,
    rx: 0.737536,
    transform: "rotate(-41.3699 180.737 67.0972)",
    fill: "#D8D8D8"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 174.309,
    y: 62.0181,
    width: 1.50957,
    height: 2.60733,
    rx: 0.754785,
    transform: "rotate(-41.3699 174.309 62.0181)",
    fill: "#D8D8D8"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 182.1,
    y: 73.9353,
    width: 1.60915,
    height: 2.77933,
    rx: 0.804576,
    transform: "rotate(-41.3699 182.1 73.9353)",
    fill: "#D8D8D8"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 175.626,
    y: 68.3589,
    width: 1.54114,
    height: 2.66186,
    rx: 0.770569,
    transform: "rotate(-41.3699 175.626 68.3589)",
    fill: "#D8D8D8"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 169.223,
    y: 63.3457,
    width: 1.60915,
    height: 2.77933,
    rx: 0.804576,
    transform: "rotate(-41.3699 169.223 63.3457)",
    fill: "#D8D8D8"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 164.224,
    y: 61.646,
    width: 1.43549,
    height: 2.47939,
    rx: 0.717746,
    transform: "rotate(-41.3699 164.224 61.646)",
    fill: "#D8D8D8"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 163.858,
    y: 59.1526,
    width: 1.13061,
    height: 1.9528,
    rx: 0.565306,
    transform: "rotate(-41.3699 163.858 59.1526)",
    fill: "#D8D8D8"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 158.506,
    y: 57.4087,
    width: 1.13061,
    height: 1.9528,
    rx: 0.565306,
    transform: "rotate(-41.3699 158.506 57.4087)",
    fill: "#D8D8D8"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 158.24,
    y: 54.8308,
    width: 0.993877,
    height: 1.71663,
    rx: 0.496939,
    transform: "rotate(-41.3699 158.24 54.8308)",
    fill: "#D8D8D8"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 153.499,
    y: 53.7939,
    width: 0.993877,
    height: 1.71663,
    rx: 0.496939,
    transform: "rotate(-41.3699 153.499 53.7939)",
    fill: "#D8D8D8"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 153.134,
    y: 51.6611,
    width: 0.993877,
    height: 1.71663,
    rx: 0.496939,
    transform: "rotate(-41.3699 153.134 51.6611)",
    fill: "#D8D8D8"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 148.468,
    y: 50.6582,
    width: 0.877638,
    height: 1.51586,
    rx: 0.438819,
    transform: "rotate(-48.8704 148.468 50.6582)",
    fill: "#D8D8D8"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 152.76,
    y: 49.5344,
    width: 0.877638,
    height: 1.51586,
    rx: 0.438819,
    transform: "rotate(-48.8704 152.76 49.5344)",
    fill: "#D8D8D8"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 157.388,
    y: 48.793,
    width: 0.877638,
    height: 1.51586,
    rx: 0.438819,
    transform: "rotate(-48.8704 157.388 48.793)",
    fill: "#D8D8D8"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 161.649,
    y: 47.697,
    width: 0.877638,
    height: 1.51586,
    rx: 0.438819,
    transform: "rotate(-48.8704 161.649 47.697)",
    fill: "#D8D8D8"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 157.015,
    y: 46.6589,
    width: 0.877638,
    height: 1.51586,
    rx: 0.438819,
    transform: "rotate(-48.8704 157.015 46.6589)",
    fill: "#D8D8D8"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 152.75,
    y: 47.7554,
    width: 0.877638,
    height: 1.51586,
    rx: 0.438819,
    transform: "rotate(-48.8704 152.75 47.7554)",
    fill: "#D8D8D8"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 148.13,
    y: 48.4968,
    width: 0.877638,
    height: 1.51586,
    rx: 0.438819,
    transform: "rotate(-48.8704 148.13 48.4968)",
    fill: "#D8D8D8"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 143.578,
    y: 47.885,
    width: 0.75767,
    height: 1.30865,
    rx: 0.378835,
    transform: "rotate(-48.8704 143.578 47.885)",
    fill: "#D8D8D8"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 148.123,
    y: 46.9841,
    width: 0.75767,
    height: 1.30865,
    rx: 0.378835,
    transform: "rotate(-48.8704 148.123 46.9841)",
    fill: "#D8D8D8"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 152.381,
    y: 45.8892,
    width: 0.75767,
    height: 1.30865,
    rx: 0.378835,
    transform: "rotate(-48.8704 152.381 45.8892)",
    fill: "#D8D8D8"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 156.649,
    y: 45.1487,
    width: 0.75767,
    height: 1.30865,
    rx: 0.378835,
    transform: "rotate(-48.8704 156.649 45.1487)",
    fill: "#D8D8D8"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 157.75,
    y: 50.5632,
    width: 0.993877,
    height: 1.71663,
    rx: 0.496939,
    transform: "rotate(-41.3699 157.75 50.5632)",
    fill: "#D8D8D8"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 162.37,
    y: 49.4666,
    width: 0.993877,
    height: 1.71663,
    rx: 0.496939,
    transform: "rotate(-41.3699 162.37 49.4666)",
    fill: "#D8D8D8"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 158.123,
    y: 52.6958,
    width: 0.993877,
    height: 1.71663,
    rx: 0.496939,
    transform: "rotate(-41.3699 158.123 52.6958)",
    fill: "#D8D8D8"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 162.74,
    y: 51.5981,
    width: 0.993877,
    height: 1.71663,
    rx: 0.496939,
    transform: "rotate(-41.3699 162.74 51.5981)",
    fill: "#D8D8D8"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 167.001,
    y: 50.5029,
    width: 0.993877,
    height: 1.71663,
    rx: 0.496939,
    transform: "rotate(-41.3699 167.001 50.5029)",
    fill: "#D8D8D8"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 163.108,
    y: 54.0859,
    width: 0.993877,
    height: 1.71663,
    rx: 0.496939,
    transform: "rotate(-41.3699 163.108 54.0859)",
    fill: "#D8D8D8"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 167.732,
    y: 52.9888,
    width: 0.993877,
    height: 1.71663,
    rx: 0.496939,
    transform: "rotate(-41.3699 167.732 52.9888)",
    fill: "#D8D8D8"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 163.482,
    y: 56.3096,
    width: 1.13061,
    height: 1.9528,
    rx: 0.565306,
    transform: "rotate(-41.3699 163.482 56.3096)",
    fill: "#D8D8D8"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 168.101,
    y: 55.2117,
    width: 1.13061,
    height: 1.9528,
    rx: 0.565306,
    transform: "rotate(-41.3699 168.101 55.2117)",
    fill: "#D8D8D8"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 172.721,
    y: 54.113,
    width: 1.13061,
    height: 1.9528,
    rx: 0.565306,
    transform: "rotate(-41.3699 172.721 54.113)",
    fill: "#D8D8D8"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 168.474,
    y: 57.6995,
    width: 1.13061,
    height: 1.9528,
    rx: 0.565306,
    transform: "rotate(-41.3699 168.474 57.6995)",
    fill: "#D8D8D8"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 173.446,
    y: 56.5986,
    width: 1.13061,
    height: 1.9528,
    rx: 0.565306,
    transform: "rotate(-41.3699 173.446 56.5986)",
    fill: "#D8D8D8"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 168.846,
    y: 60.3882,
    width: 1.43549,
    height: 2.47939,
    rx: 0.717746,
    transform: "rotate(-41.3699 168.846 60.3882)",
    fill: "#D8D8D8"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 173.818,
    y: 59.2874,
    width: 1.43549,
    height: 2.47939,
    rx: 0.717746,
    transform: "rotate(-41.3699 173.818 59.2874)",
    fill: "#D8D8D8"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 178.63,
    y: 58.054,
    width: 1.26575,
    height: 2.1862,
    rx: 0.632873,
    transform: "rotate(-41.3699 178.63 58.054)",
    fill: "#D8D8D8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1497 95.3938C40.8016 94.9782 40.6283 93.7216 40.5636 92.8611C40.5434 92.593 40.6951 92.2092 40.908 92.3734C41.3317 92.7 41.5789 94.4249 41.6597 95.4478C41.6597 95.6617 41.4259 95.5794 41.265 95.4872C41.2216 95.4624 41.1818 95.4321 41.1497 95.3938Z",
    fill: "#CACACA"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3909 100.356C43.0428 99.9404 42.8695 98.6837 42.8048 97.8233C42.7846 97.5552 42.9363 97.1714 43.1492 97.3355C43.573 97.6622 43.8201 99.387 43.9009 100.41C43.9009 100.624 43.6671 100.542 43.5062 100.449C43.4628 100.425 43.423 100.394 43.3909 100.356Z",
    fill: "#CACACA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1575 113.288L45.0234 104.26C46.5571 104.986 47.9326 106.966 48.4015 107.801C49.2148 109.502 49.2443 112.168 49.1575 113.288Z",
    fill: "#CACACA"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1703 103.601L44.4584 98.8088C44.4395 99.5963 44.4111 100.777 44.9572 101.578C45.3866 102.208 46.6099 103.391 47.1703 103.601Z",
    fill: "#CACACA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0826 104.338C44.4159 103.495 44.4693 101.106 44.4334 99.989C44.5791 101.765 46.246 102.987 47.1737 103.6C47.7613 104.245 48.1653 106.776 48.2091 107.565C46.5659 105.358 45.4349 104.565 45.0826 104.338Z",
    fill: "#D5D5D5"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M179.869 126.912L176.629 111.676L208.382 118.662L201.961 120.88L219.753 131.396L207.012 136.056L187.686 124.341L179.869 126.912Z",
    fill: "#DF9090"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M265.288 157.558L258.35 161.496L257.191 168.95L264.162 164.799L265.288 157.558Z",
    fill: "#E1C143"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M251.475 148.212L243.732 153.115L258.353 161.497L265.291 157.558L251.475 148.212Z",
    fill: "#FFF4AC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M242.448 161.421L243.739 153.115L258.36 161.496L257.201 168.95L242.448 161.421Z",
    fill: "#FFD65E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_18480_1266",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 242,
    y: 148,
    width: 24,
    height: 21
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M251.474 148.21L243.731 153.114L258.352 161.495L265.29 157.557L251.474 148.21Z",
    fill: "#505050"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M242.44 161.42L243.731 153.114L258.352 161.495L257.193 168.949L242.44 161.42Z",
    fill: "#505050"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_18480_1266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.142 149.28L245.94 154.331L245.709 155.821L245.477 157.312",
    stroke: "#E0C472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.583 163.063L245.08 159.868M247.22 164.345L247.717 161.151M249.889 165.415L250.386 162.22M252.525 166.697L253.022 163.503M255.129 168.193L255.625 164.998",
    stroke: "#E0C472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.502 150.955L248.546 155.826L248.049 159.021",
    stroke: "#E0C472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.679 152.386L251.149 157.323L250.686 160.305",
    stroke: "#E0C472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.038 154.061L253.754 158.818L253.323 161.586",
    stroke: "#E0C472"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.6 155.769L256.349 160.313L255.886 163.295",
    stroke: "#E0C472"
  }))), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M245.863 143.63L235.612 149.234L243.734 153.115L251.477 148.211L245.863 143.63Z",
    fill: "#F9EA9D"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M234.182 158.393L235.606 149.235L243.728 153.116L242.436 161.422L234.182 158.393Z",
    fill: "#FFD958"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M212.94 146.977L213.391 139.779L231.398 149.438L231.837 147.264L235.61 149.235L234.185 158.393L212.94 146.977Z",
    fill: "#EBC636"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M226.335 135.193L241.384 142.603L231.852 147.294L231.422 149.453L213.391 139.778L226.335 135.193Z",
    fill: "#F0D361"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_18480_1266",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 213,
    y: 135,
    width: 29,
    height: 15
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M226.337 135.191L241.386 142.601L231.855 147.292L231.424 149.451L213.393 139.776L226.337 135.191Z",
    fill: "#E7E0C8"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_18480_1266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.947 140.307L224.396 135.872",
    stroke: "#D1B460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.379 140.917L222.828 136.483",
    stroke: "#D1B460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.535 141.54L220.984 137.106",
    stroke: "#D1B460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.606 142.258L219.055 137.824",
    stroke: "#D1B460"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.596 143.067L217.045 138.633",
    stroke: "#D1B460"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M245.844 143.638L235.599 149.254L231.852 147.296L242.603 141.962L245.844 143.638Z",
    fill: "#E9DA90"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.707,
    cy: 163.384,
    rx: 1.50257,
    ry: 2.80205,
    transform: "rotate(31.8491 261.707 163.384)",
    fill: "#EADEB1"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 262.907,
    y: 160.832,
    width: 34.2451,
    height: 5.6041,
    transform: "rotate(31.8491 262.907 160.832)",
    fill: "#EADEB1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18480_1266",
    x: 0,
    y: 42.5835,
    width: 225.315,
    height: 160.249,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -12,
    dy: 22
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.5875 0 0 0 0 0.5875 0 0 0 0 0.5875 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18480_1266"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18480_1266",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18480_1266",
    x1: 54.4977,
    y1: 104.331,
    x2: 48.1102,
    y2: 108.944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCDCDC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18480_1266",
    x1: 49.3523,
    y1: 73.28,
    x2: 205.315,
    y2: 81.6193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9E9E9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18480_1266",
    x1: 206.531,
    y1: 77.4606,
    x2: 72.4868,
    y2: 119.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18480_1266",
    x1: 40.3003,
    y1: 94.0392,
    x2: 65.8504,
    y2: 151.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D6D2D2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18480_1266",
    x1: 57.3345,
    y1: 136.269,
    x2: 37.9944,
    y2: 136.269,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBC8C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCDCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_18480_1266",
    x1: 41.0136,
    y1: 124.736,
    x2: 47.0462,
    y2: 127.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6A7A4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_18480_1266",
    x1: 41.0123,
    y1: 124.735,
    x2: 47.045,
    y2: 127.042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4A4A4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthernetOnboard);
export default __webpack_public_path__ + "static/media/ethernetOnboard.c143825ee0239f39e5aece811218bcd2.svg";
export { ForwardRef as ReactComponent };